import React, { useEffect, forwardRef } from 'react';
import { Box, Button, Dialog, DialogContent, DialogTitle, Grid, IconButton, Tooltip } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';

const ScanView = forwardRef(({ isOpen, onClose, pages, numPages }, ref) => {
  
  const [imagePreview, setImagePreview] = React.useState({ open: false, src: '', alt: '' });
  useEffect(() => {
    // Add any side effect code here
  }, [isOpen]);

  const openImagePreview = (b64, alt='') => {
    setImagePreview({ open: true, src: `data:image/png;base64,${b64}`, alt });
  };
  
  const closeImagePreview = () => setImagePreview({ open: false, src: '', alt: '' });

  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle>Scan</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          {[...Array(numPages)].map((_, index) => (
            <Grid
              item
              xs={12} // 1 images per row. If 3 imgs per row set to 4 since 12 / 4 = 3 (Prev version)
              key={index}
              style={{
                textAlign: 'center',
              }}
              position="relative"
            >
              {pages[index] !== null && (
                <div style={{position: "relative", display: "inline-block"}}>
                  <Tooltip title="Click to view full image" arrow>
                <IconButton
                onClick={(e) => openImagePreview(pages[index])}
                sx={{
                  position: 'absolute',
                  top: "50%", 
                  left: "50%", 
                  transform: "translate(-50%, -50%)", 
                  color: 'rgba(255, 255, 255, 0.8)', 
                  backgroundColor: 'rgba(0, 0, 0, 0.5)', 
                  marginTop: '-1rem', 
                  '&:hover': {
                    backgroundColor: 'rgba(0, 0, 0, 0.8)',
                  },
                }}>
                  <OpenInFullIcon />
                </IconButton>
                </Tooltip>
                  <a href="#" onClick={(e) => openImagePreview(pages[index])}>
                    <img
                      src={`data:image/jpeg;base64,${pages[index]}`}
                      alt={`Page ${index + 1}`}
                      style={{ width: 120, height: 'auto', marginBottom: '8px' }}
                    />
                  </a>
                  <br />
                  <span>{`Page ${index + 1}`}</span>
                </div>
              )}
            </Grid>
          ))}
        </Grid>
      </DialogContent>
      <Button onClick={onClose} style={{ position: 'absolute', top: 0, right: 0 }}>
        <CloseIcon />
      </Button>
      <Dialog open={imagePreview.open} onClose={closeImagePreview} maxWidth="md" fullWidth>
        <Box sx={{ p: 2, display: 'flex', justifyContent: 'center', position: "relative" }}>
          <IconButton
          onClick={closeImagePreview}
          style={{
            width: "25px", 
            height: "25px",
            position: 'absolute',
            top: "2rem", 
            right: "1rem", 
            color: 'rgba(255, 255, 255, 0.8)', 
            backgroundColor: 'rgba(0, 0, 0, 0.6)', 
            margin: '5px', 
            '&:hover': {
              backgroundColor: 'rgba(0, 0, 0, 0.8)',
            },
          }}>
            <CloseIcon />
          </IconButton>
          <img
          src={imagePreview.src}
          alt={imagePreview.alt || 'Preview'}
          style={{ maxWidth: '100%', height: 'auto' }}
          />
        </Box>
      </Dialog>
    </Dialog>
  );
});

export default ScanView;
